/**
 * Data point's matching type.
 * tag: 2782
 * @readonly
 * @enum {number} (int)
 */
export enum MatchingDataPointIndicator {
  /** Mandatory */
  Mandatory = 1,
  /** Optional */
  Optional = 2,
}
